export default function login(state = "", action) {
    switch (action.type) {
        case "SET_BROKER_LOG":
            return action.payload;
        default:
            return state;
    }
}
